import { calculateBMI } from './components/Helpers/Conversion';

const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

// account should be the only one using this
// all items will be cleared when account/session expires
function setSessionStorageItemWithExpiration(key, value, timeoutInMinutes) {
  const now = new Date();

  const expireTime = new Date(now.getTime() + timeoutInMinutes * 60000);

  const storeItem = {
    value: value,
    expiration: expireTime,
  };

  try {
    sessionStorage.setItem(key, JSON.stringify(storeItem));
  } catch (e) {
    if (e.code === 22) {
      console.log('Session storage full.');
    }
  }
}

function setSessionStorageItem(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    if (e.code === 22) {
      console.log('Session storage full.');
    }
  }
}

function setQuotesToCompare(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

function getQuotesToCompare(key) {
  const item = sessionStorage.getItem(key);
  if (!item) {
    window.location = '/Products/asset-based-ltc/quote';
  } else return JSON.parse(item);
}

function getSessionStorageItem(key) {
  const item = sessionStorage.getItem(key);

  if (!item) {
    return null;
  }

  const itemJson = JSON.parse(item);

  if (!itemJson) {
    return null;
  }

  if (itemJson.expiration) {
    const currentTime = new Date();
    const expireTime = new Date(itemJson.expiration);

    if (currentTime > expireTime) {

      if (shouldRedirect()) {
        sessionStorage.clear();

        // redirect to home screen after expiration
        window.location = '/';

        return null;
      }
    } else {
      // if expiring item, extend timeline
      setSessionStorageItemWithExpiration(key, itemJson.value, 60);
    }
  }

  return itemJson.value || itemJson;
}

function shouldRedirect() {
  let currentURL = window.location.href.split('/');
  const pagesToPreventRedirectOnExpire = ['status', 'landing', 'retrieveprogress'];

  // remove any query strings
  currentURL = currentURL.map((url) => url.split('?')[0]);

  if (currentURL.some((urlSegment) => pagesToPreventRedirectOnExpire.includes(urlSegment.toLowerCase()))) {
    return false;
  }

  return true;
}

// define the standard basic info data
var basicInfo = {
  firstName: null,
  lastName: null,
  phone: null,
  gender: null,
  birthdate: null,
  tobacco: null,
  state: null,
  height: null,
  weight: null,
  email: null,
  usResident: null,
  replacePolicy: null,
  preQuoteHealthClass: null,
  preQuoteAbbreviatedQualified: null,
  bmi: null,
  coverageLength: null,
  faceAmount: null,
  healthClass: null,
  income: null,
};

// Grab Basic Info from localstorage, if not there return a new one
function getBasicInfo() {
  var basicInfoFromStorage = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_BASIC_INFO_KEY)) || basicInfo;

  if (!basicInfoFromStorage.birthdate && getSessionStorageItem(SESSION_STORAGE_CLIENTINFO_KEY)) {
    var clientInfo = getSessionStorageItem(SESSION_STORAGE_CLIENTINFO_KEY);
    basicInfoFromStorage.phone = clientInfo.phone;
    basicInfoFromStorage.gender = clientInfo.gender;
    basicInfoFromStorage.birthdate = clientInfo.dateOfBirth;
    basicInfoFromStorage.tobacco = String(clientInfo.tobacco);
    basicInfoFromStorage.state = clientInfo.state;
    basicInfoFromStorage.height = clientInfo.heightString;
    basicInfoFromStorage.weight = clientInfo.weightString;
    basicInfoFromStorage.email = clientInfo.email;
    basicInfoFromStorage.usResident = clientInfo.usResident;
    basicInfoFromStorage.replacePolicy = clientInfo.replacePolicy;
    basicInfoFromStorage.bmi = calculateBMI(clientInfo.totalInches, clientInfo.weight) || undefined;
    basicInfoFromStorage.coverageLength = clientInfo.termLength;
    basicInfoFromStorage.faceAmount = clientInfo.faceAmount;
    basicInfoFromStorage.healthClass = clientInfo.healthClass;
    basicInfoFromStorage.firstName = clientInfo.firstName;
    basicInfoFromStorage.lastName = clientInfo.lastName;
    basicInfoFromStorage.income = clientInfo.income;
    basicInfoFromStorage.termLength = clientInfo.termLength;
  }

  return basicInfoFromStorage;
}

// Save Basic Info to local storage
function setBasicInfo(basicInfo) {
  sessionStorage.setItem(SESSION_STORAGE_BASIC_INFO_KEY, JSON.stringify(basicInfo));
}

// getAgentID
const getAgentID = () => {
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  return advisorObj && advisorObj.agentID;
}

const getAccountDetails = () => {
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  return (accountObj && accountObj.account != null) ? accountObj.account : {};
};

// getAgentRole
const getAgentRole = () => {
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  return advisorObj && advisorObj.role;
}

// getAgentName
const getAgentName = () => {
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  return {
    firstName: advisorObj && advisorObj.firstName ? (advisorObj.firstName).trim() : '',
    lastName: advisorObj && advisorObj.lastName ? (advisorObj.lastName).trim() : '',
  }
}

export { setSessionStorageItemWithExpiration, setQuotesToCompare, setSessionStorageItem, getQuotesToCompare, getSessionStorageItem, getBasicInfo, setBasicInfo, getAgentID, getAccountDetails, getAgentRole, getAgentName };

// keys
export const SESSION_STORAGE_ACCOUNT_KEY = 'ACCOUNT_OBJECT';
export const SESSION_STORAGE_ESIGN_AUTH_KEY = 'ESIGN_AUTH';
export const SESSION_STORAGE_IS_AUTH_KEY = 'IS_AUTH';
export const SESSION_STORAGE_IS_SIGN_WITHOUT_AUTH = 'IS_SIGN_WITHOUT_AUTH';
export const SESSION_STORAGE_ROUTING_KEY = 'ROUTING';
export const SESSION_STORAGE_NEEDS_ANALYSIS_KEY = 'INSURANCE_NEEDS_ANALYSIS';
export const SESSION_STORAGE_BASIC_INFO_KEY = 'BASIC_INFO';
export const SESSION_STORAGE_CLIENTINFO_KEY = 'CLIENTINFO_OBJECT';
export const ADVISOR_OBJECT_KEY = 'ADVISOR_OBJECT';
export const SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY = 'TERM_LIFE_INSURANCE';
export const SESSION_STORAGE_SCHEDULE_APPOINTMENT_KEY = 'SCHEDULE_APPOINTMENT_KEY';
export const SESSION_STORAGE_SPL_KEY = 'SESSION_STORAGE_SPL_KEY';
export const SERVICES_BASE_URL_KEY = 'SERVICES_BASE_URL_KEY';
export const SESSION_STORAGE_TERM_REVIEW_OBJECT_KEY = "TERM_REVIEW";
export const SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY = "PERM_REVIEW";
export const SESSION_STORAGE_ATTESTATION = "ATTESTATION_KEY";
export const SESSION_STORAGE_INDEX_UNIVERSAL_LIFE = "INDEX_UNIVERSAL_LIFE";
export const SESSION_STORAGE_SUBMIT_A_CASE = "SUBMIT_A_CASE";
export const SESSION_STORAGE_REQUEST_AN_ILLUSTRATION = "REQUEST_AN_ILLUSTRATION";
export const SESSION_STORAGE_BASIC_INFO_SUMMARY = "BASIC_INFO_SUMMARY";
export const SESSION_STORAGE_AUTH_TOKEN = "AUTH_TOKEN";
export const SESSION_STORAGE_ASSET_BASED_LTC = "ASSET_BASED_LTC";
export const SESSION_STORAGE_GUARANTEED_UNIVERSAL_LIFE = "GUARANTEED_UNIVERSAL_LIFE";
export const SESSION_STORAGE_UNIVERSAL_LIFE = "UNIVERSAL_LIFE";
export const SESSION_STORAGE_TERM_CONVERSION_REQUEST = "TERM_CONVERSION_REQUEST";



// WEBPACK FOOTER //
// ./src/sessionStorage.js